<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div class="add-to-portfolio">
        <Portal v-if="instruments" to="breadcrumb_addEtfToPortfolio">
          Zu Portfolio hinzufügen
        </Portal>

        <fin-add-to-portfolio :action="action"
                              :instruments="instruments"
                              :portfolioId="portfolioId"
                              :title="title"
                              :to="to"/>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinAddToPortfolio from '@/components/common/portfolio/AddToPortfolio/index'
import FinDataLoader from "@/components/common/DataLoader"
import {finEtfAPI, finPortfolioAPI} from "@/js/finAPI"

export default {
  name: 'fin-etf-page-add-to-portfolio',
  components: {
    FinDataLoader,
    FinAddToPortfolio
  },
  props: {
    id: {
      type: String
    },
    action: {
      type: String
    },
    portfolioId: {
      type: String
    },
    assetClassId: {
      type: String
    }
  },
  data() {
    return {
      instruments: [],
      to: null,
      title: null,
    }
  },
  methods: {
    async loadData() {
      // coming from portfolio
      if (this.portfolioId) {
        const result = await finPortfolioAPI.getPortfolio(this.portfolioId)
        const etfs = result.etfEntries.items
        let etfById = etfs.find(e => e.instrument.id === this.id)
        this.instruments = [etfById.instrument]
        this.to = {name: 'portfolioDetail', params: {id: this.portfolioId}}
      }
      // coming from etf page -> read etf by id
      else if (this.id) {
        let result = []

        this.to = {name: 'etfDetail', params: {id: this.id}}
        result.push(await finEtfAPI.getMinimalEtf(this.id))
        this.title = 'Wertpapier in Portfolio hinzufügen'

        this.instruments = result
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-portfolio {
  background-color: #fff;
}
</style>
